<script lang="ts" setup>
import LoginModal from "@uicomps/modals/auth/LoginModal.vue";
import BlankOverlay from "@overlay/layouts/BlankOverlay.vue";
import { onBeforeMount, onMounted } from "vue";
import { mobilePortrait } from "@/mobile/postMessage";
import { ignoreDownloadStep } from "@overlay/components/modals/auth/Signup/SignupSteps";
import { useRoute } from "vue-router";

// onMounted(async () => {
//   dispatchEvent(EnumUiEvents.UiMounted);
//   if ((navigator as any).wakeLock) {
//     SCREEN_LOCK.value = await (navigator as any).wakeLock.request("screen");
//   }
// });
const route = useRoute();

onMounted(() => {
  mobilePortrait();
});

onBeforeMount(() => {
  if (route.query["utm_source"] == "telegram-bot") {
    ignoreDownloadStep.value = true;
  }
});
</script>
<template>
  <blank-overlay>
    <div class="background">
      <img class="cloud1" src="/assets/overlay/login/cloud1.png" />
      <img class="cloud2" src="/assets/overlay/login/cloud3.png" />
      <img class="cloud3" src="/assets/overlay/login/cloud2.png" />
      <img class="cloud4" src="/assets/overlay/login/cloud1.png" />
      <img class="cloud5" src="/assets/overlay/login/cloud4.png" />
      <img class="bitcoinCloud" src="/assets/overlay/login/cloud_bitcoin.png" />
      <img class="cloud6" src="/assets/overlay/login/cloud4.png" />
      <img class="cloud7" src="/assets/overlay/login/cloud4.png" />
      <img class="cloud8" src="/assets/overlay/login/cloud_small.png" />

      <img class="building" src="/assets/overlay/login/login-building.svg" />
    </div>

    <login-modal :visible="true" />
  </blank-overlay>
</template>

<style lang="scss">
.background {
  width: 100vw;
  height: 100vh;
  background: #c1ebf9;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 5555;
  overflow: hidden;

  img {
    position: absolute;
  }

  .building {
    position: absolute;
    bottom: -50px;
    left: 0;
    right: 0;
    margin: auto;
  }

  .cloud1 {
    top: 50px;
    left: -30px;
  }

  .cloud2 {
    top: 0px;
    right: 0px;
    width: 500px;
  }

  .cloud3 {
    top: 160px;
    right: 0px;
    width: 150px;
  }

  .cloud4 {
    top: 90px;
    right: 0px;
    left: -550px;
    margin: auto;
    width: 250px;
  }

  .cloud5 {
    top: 130px;
    right: -740px;
    left: 0px;
    margin: auto;
    width: 350px;
  }

  .cloud6 {
    top: 330px;
    right: 0px;
    left: -1200px;
    margin: auto;
    width: 350px;

    animation: cloudSidewaysRightDownAnimation 10s infinite;
    animation-timing-function: linear;
  }

  .cloud7 {
    top: 550px;
    left: -100px;
    width: 350px;

    animation: cloudSidewaysRightAnimation 8s infinite;
    animation-timing-function: linear;
  }

  .cloud8 {
    top: 100px;
    margin: auto;
    left: -1000px;
    right: 0;
    width: 60px;

    animation: cloudSidewaysLeftAnimation 8s infinite;
    animation-timing-function: linear;
  }

  .bitcoinCloud {
    top: 430px;
    right: -740px;
    left: 0px;
    margin: auto;
    width: 350px;

    animation: bitcoinCloudAnimation 8s infinite;
    animation-timing-function: linear;
  }
}

@keyframes bitcoinCloudAnimation {
  0% {
    right: -740px;
  }
  50% {
    right: -690px;
    transform: rotate(20deg);
  }
  100% {
    right: -740px;
  }
}

@keyframes cloudSidewaysLeftAnimation {
  0% {
    left: -1000px;
  }
  50% {
    left: -1050px;
  }
  100% {
    left: -1000px;
  }
}

@keyframes cloudSidewaysRightAnimation {
  0% {
    left: -100px;
  }
  50% {
    left: -50px;
  }
  100% {
    left: -100px;
  }
}

@keyframes cloudSidewaysRightDownAnimation {
  0% {
    top: 330px;
    left: -1200px;
  }
  50% {
    top: 360px;
    left: -1100px;
  }
  100% {
    top: 330px;
    left: -1200px;
  }
}
</style>
